<template>
  <el-select
    class="address-select global-address-pick"
    :size="size"
    :value="selectedKey"
    filterable
    remote
    clearable
    :loading="loading"
    placeholder="Input something to search address"
    :remote-method="fetchAddressList"
    @change="handleChange"
  >
    <el-option
      v-for="address in addressList"
      :key="address.id"
      :label="getAddressLabel(address)"
      :value="address.id"
    >
      <div class="select-option-wrapper">
        <div class="code bold-oswald">{{ address.code }}</div>
        <div class="address">
          <div class="select-option-inner">
            <span :title="address.name">{{ address.name }}</span>
            <span :title="address.street">{{ address.street }}</span>
            <span :title="address.city">{{ address.city }}</span>
            <span :title="address.state">{{ address.state }}</span>
            <span :title="address.zip">{{ address.zip }}</span>
          </div>
        </div>
      </div>
    </el-option>
  </el-select>
</template>
<script>
import { queryAddress } from '@/api/address'
export default {
  name: 'AddressPick',
  props: {
    value: {
      required: true
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  data() {
    return {
      loading: false,
      addressList: []
    }
  },
  computed: {
    selectedKey() {
      return this.value?.id ?? ''
    }
  },
  watch: {
    selectedKey() {
      this.useCurrentAsOption()
    }
  },
  methods: {
    fetchAddressList(query) {
      this.loading = true
      queryAddress({ size: -1, fuzzyAll: query.toUpperCase() })
        .then(res => {
          this.addressList.splice(0, this.addressList.length)
          this.addressList.push(...res.records)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getAddressLabel(address) {
      return [address.code, address.name, address.street, address.city].join(
        ', '
      )
    },
    handleChange(id) {
      const address = this.addressList.find(one => one.id === id)
      this.$emit('input', address)
      this.$emit('change', address)
    },
    useCurrentAsOption() {
      if (
        this.value &&
        'code' in this.value &&
        'id' in this.value &&
        this.value.id
      ) {
        const index = this.addressList.findIndex(
          one => one.id === this.value.id
        )
        if (index === -1) this.addressList.push(this.value)
      }
    }
  },
  mounted() {
    this.useCurrentAsOption()
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.address-select {
  width: 100%;
}

.select-option-wrapper {
  gap: 20px;

  @extend .f-r;
}

.select-option-inner {
  display: flex;
  flex-direction: row;
  gap: 5px;
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
  }
}
</style>
